import { render } from "./EditCartItemModal.vue?vue&type=template&id=2060929f&scoped=true&ts=true"
import script from "./EditCartItemModal.vue?vue&type=script&lang=ts"
export * from "./EditCartItemModal.vue?vue&type=script&lang=ts"

import "./EditCartItemModal.vue?vue&type=style&index=0&id=2060929f&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2060929f"]])

export default __exports__